module.exports = __webpack_public_path__ + "img/vege.8de700be.png";